module.exports = __webpack_public_path__ + "img/type_ppt.f903ec43.svg";